import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { CircularProgress } from "@material-ui/core";
import { putRequest } from "utils/request";
import ClientForm from "components/ClientForm";
import { format } from "date-fns";
import { getRequest } from "utils/request";
import { i18n } from '../../../translate/i18n';

import {
  Dialog,
  DialogContent,
  AppBar,
  IconButton,
  Typography,
  Toolbar,
  Button,
} from "@material-ui/core";
//import CloseIcon from "@material-ui/icons/Close";

import "../style.css";
import { postRequest } from "utils/request";
import { useNotification } from "hooks/notification";

export default function SearchClient({
  CustomerAllData,
  ticketid,
  handleUpdateTicketUser,
}) {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [loadingclient, setLoadingClient] = useState(false);
  const [loadingSelect, setLoadingSelect] = useState(false);
  const [ShowFormClient, setShowFormClient] = useState(false);
  const [selectedClient, setSelectedClient] = useState("");
  const [allListClients, setAllListClients] = useState([]);
  const [newCustomerData, setNewCustomerData] = useState("");

  const { selectedCompany } = useNotification();

  useEffect(() => {
    setShowFormClient(false);
  }, [ticketid]);

  const handleGetUser = () => {
    if (selectedClient !== "") {
      setLoadingClient(true);
      setShowFormClient(false);

      //Busca lista Usuários
      getRequest(
          `customers?CustomerId=${CustomerAllData.id}&text=${selectedClient}&CompanyId=${selectedCompany.id}&offset=0&limit=100`
        )
        .then(function (response) {
          if(response.data) {
            setAllListClients(response.data);
          }
            setLoadingSelect(false);
            setLoadingClient(false);
        });
    }
  };

  const handleUnify = () => {
    Swal.fire({
      title: i18n.t('attemption'),
      text: i18n.t('confirmUnify'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t('acceptUnify'),
    }).then((result) => {
      if (result.isConfirmed) {
        postRequest(`customers/unify`, {
            oldCustomerId: newCustomerData.id,
            newCustomerId: CustomerAllData.id,
          })
          .then(function (response) {
              setSelectedClient("");
              setAllListClients([]);
              setNewCustomerData("");

              handleUpdateTicketUser();
              setShowFormClient(false);
          });
      }
    });
  };

  const handleSelectedClient = (data) => {
    setNewCustomerData(data);
    setShowFormClient(true);
  };

  const handleCloseForm = () => {
    setShowFormClient(false);
    handleGetUser();
  };

  const handleConfirm = async (customer) => {
    setLoading(true);

    //SALVA ALTERAÇÕES DO CLIENTE
    await putRequest(`/customers/${customer.id}`, customer);
    setLoading(false);
  };

  return (
    <>
      {!loadingSelect ? (
        <>
          <form
            style={{ marginTop: 20 }}
            onSubmit={(event) => {
              event.preventDefault();
              handleGetUser();
            }}
          >
            <div className="form-group" style={{ display: "flex" }}>
              <input
                type="text"
                className="form-control"
                placeholder={i18n.t('search')}
                style={{
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                }}
                onChange={(value) => setSelectedClient(value.target.value)}
              />
              <button type="submit" className="btn-search-list-tickets">
                {loadingclient ? (
                  <CircularProgress size={15} />
                ) : (
                  <span className="mdi mdi-magnify search-icon"></span>
                )}
              </button>
            </div>
          </form>
        </>
      ) : (
        <CircularProgress className="loading-area-select" />
      )}
      <div className="container-geral-edit-client">
        <div className="area-customers-search-list">
          {allListClients.map((data, index) => (
            <div
              key={index}
              className="item-customers-search-list"
              onClick={() => handleSelectedClient(data)}
            >
              <p>{i18n.t('name')} : {data.name}</p>
              <p>{i18n.t('document')}: {data.document}</p>
              <p>{i18n.t('document')}: {data.cellPhone}</p>
              <p>
                {i18n.t('bornDate')}: {format(new Date(data.dateBirth), "dd/MM/yyyy")}
              </p>
            </div>
          ))}
        </div>
      </div>
      <Dialog
        fullScreen
        open={ShowFormClient}
        onClose={handleCloseForm}
        style={{ zIndex: 1010 }}
      >
        <AppBar color="default" className="appbar-unify-page">
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseForm}
              aria-label="close"
            >
              {/* <CloseIcon /> */}X
            </IconButton>
            <Typography variant="h6" className="title-unify-page">
              {i18n.t('unifyClient')}
            </Typography>
            <Button autoFocus color="inherit" onClick={handleUnify}>
              {i18n.t('unify')}
            </Button>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <div className="area-forms-unify-page">
            <div style={{ height: "85%" }}>
              <h1>{i18n.t('newContact')}</h1>
              <ClientForm
                CustomerData={CustomerAllData}
                handleConfirm={handleConfirm}
              />
            </div>
            <div style={{ height: "85%" }}>
              <h1>{i18n.t('finalRegister')}</h1>
              <ClientForm
                CustomerData={newCustomerData}
                handleConfirm={handleConfirm}
              />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
